import Frame from "../Frames/Basic";
import { Alert} from "@mui/material";
import { useEffect, useState } from "react";
import Loader from "../Tools/Loader";
import { useParams, useSearchParams } from "react-router-dom";
import API from "../../services/API/API";
import Order from "./Order";

export default function Index(){

    const {uuid} = useParams()
    const [params] = useSearchParams()

    const [order, setOrder] = useState(null)
    const [status, setStatus] = useState('loading')

    const statusIs = s => status === s

    useEffect(() => {

        API.get(`/orders/${uuid}`)
            .then(r => {
                setOrder(r.data)
                setStatus('ready')
            })
            .catch(e => setStatus('error'))
        
    }, [uuid])

    
    return <Frame>

        {statusIs('loading') &&
            <Loader />
        }


        {statusIs('error') && 
            <Alert severity='error'>Une erreur s'est produite. Veuillez réessayer ultérieurement.</Alert>
        }

        <Order 
            order={order} 
            onChange={order => setOrder(order)}
            readOnly={params.has('readonly')}
        />

    </Frame>
}